import type { MapViewState } from "../types";

const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
const arabicDigits = "٠١٢٣٤٥٦٧٨٩";

export function normalizeDigits(value: string): string {
  return value.replace(/[۰-۹٠-٩]/g, (digit) => {
    const persianIndex = persianDigits.indexOf(digit);
    if (persianIndex >= 0) return String(persianIndex);
    const arabicIndex = arabicDigits.indexOf(digit);
    return arabicIndex >= 0 ? String(arabicIndex) : digit;
  });
}

export function parseCoordinateQuery(query: string): { lat: number; lon: number } | null {
  const normalized = normalizeDigits(query.trim()).replace("،", ",");
  const match = normalized.match(/^\s*([+-]?\d+(?:\.\d+)?)\s*,\s*([+-]?\d+(?:\.\d+)?)\s*$/);
  if (!match) return null;
  const lat = Number(match[1]);
  const lon = Number(match[2]);
  if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;
  if (lat < -90 || lat > 90 || lon < -180 || lon > 180) return null;
  return { lat, lon };
}

export function clampView(view: MapViewState): MapViewState {
  return {
    lat: Math.min(90, Math.max(-90, view.lat)),
    lon: Math.min(180, Math.max(-180, view.lon)),
    zoom: Math.min(22, Math.max(0, view.zoom)),
    pitch: Math.min(85, Math.max(0, view.pitch)),
    bearing: Number.isFinite(view.bearing) ? view.bearing : 0,
  };
}
